<div>
  <app-modules-shared-top-menu></app-modules-shared-top-menu>
  <div class="content-holder">
    <div class="feedback-notice-hld">
      <div class="feedback-notice">
        <div class="feedback-notice-title">{{ 'translateFeedbackNoticeTitle' | translate }}</div>
        <p>{{ 'translateFeedbackNoticeIntro' | translate }}</p>
        <p>
          {{ 'translateFeedbackNoticeInterim' | translate }}<br>
          <a class="feedback-notice-mail" href="mailto:feedback.mv@vitecsoftware.com">feedback.mv&#64;vitecsoftware.com</a>
        </p>
        <p>{{ 'translateFeedbackNoticeThanks' | translate }}</p>
      </div>
    </div>
  </div>
  <!-- Temporarily hidden until the new feedback page is ready. -->
  <!--
  <div class="content-holder">
    <div class="content-hld">
      <div class="main-col-hld">
        <div class="main-title">{{ 'translatefeedback' | translate }}</div>
        <div class="feedback-main-hld">
          <div #feedbackSection class="platform-hld">
            <div class="label" [ngClass]="{'invalid-label': invalidSections().platform}">{{ 'translatePlatform' |
              translate }} <span class="red-txt">*</span></div>
              <div class="feedback-icons-hld center-flex platform-hld">
                @for (item of platforms(); track item.type) {
                  <div class="padd-tb-10">
                    <div class="feedback-icon center-flex" (click)="selectPlatform(item)"
                      [ngClass]="{'active': item.selected}">
                      @if (item.icon) {
                        <mat-icon [svgIcon]="item.icon" [ngClass]="item.icon"></mat-icon>
                      }
                      {{item.type}}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div #feedbackSection>
              <div class="label" [ngClass]="{'invalid-label': invalidSections().feedbackType}">{{ 'translateFeedbackType' |
                translate }} <span class="red-txt">*</span></div>
                <div class="feedback-icons-hld center-flex">
                  @for (item of feedbackTypes(); track item.type) {
                    <div class="padd-tb-10">
                      <div class="feedback-icon center-flex" (click)="setFeedbackType(item)"
                        [ngClass]="{'active': item.selected}">
                        @if (item.icon) {
                          <mat-icon [svgIcon]="item.icon" [ngClass]="item.icon"></mat-icon>
                        }
                        {{'translate'+item.type | translate}}
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div #feedbackSection>
                <div class="label" [ngClass]="{'invalid-label': invalidSections().satisfaction}">{{
                  'translateSatisfactionLevel' | translate }} <span class="red-txt">*</span></div>
                  <div class="satisfaction-icons-hld center-flex padd-b-24">
                    @for (item of satisfactionLevels(); track item.type) {
                      <div class="padd-tb-10">
                        <div class="feedback-icon faces" (click)="setLevel(item)" [ngClass]="{'active': item.selected}">
                          @if (item.icon) {
                            <mat-icon [svgIcon]="item.icon" [ngClass]="'icon-'+item.type"></mat-icon>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div #feedbackSection>
                  <div class="label" [ngClass]="{'invalid-label': invalidSections().features}">{{ 'translateAffectedFeature' |
                    translate }} <span class="red-txt">*</span></div>
                    <div class="features-icons-hld center-flex">
                      @for (item of features(); track item.type) {
                        <div class="features">
                          <div class="feedback-feature-icon" (click)="setFeatures(item)" [ngClass]="{'active': item.selected}"
                            matTooltip="{{ 'translate'+item.type | translate }}">
                            @if (item.icon) {
                              <mat-icon class="feature-ic" [svgIcon]="item.icon" [ngClass]="item.type"></mat-icon>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="label">{{ 'translateOpinionSuggestion' | translate }}</div>
                  <div class="textarea-hld">
                    <textarea rows="4" class="padd-20" [(ngModel)]="suggestion" name="suggest"></textarea>
                  </div>
                  <div class="label" [ngClass]="{'invalid-label': !isEmailValid()}">{{ 'translateEmail' | translate }}</div>
                  <div class="input-hld" [ngClass]="{'invalid-email': !isEmailValid()}">
                    <input type="email" [(ngModel)]="email" name="email">
                  </div>
                  <div class="label">{{ 'translatePhoneNumber' | translate }}</div>
                  <div class="input-hld">
                    <input type="number" [(ngModel)]="phoneNumber" name="phone">
                  </div>
                  <div class="nav-hld center-flex">
                    <div class="nav-btn center-flex" (click)="resetFields()">{{ 'translateCancel' | translate }}</div>
                    <div class="nav-btn send-btn center-flex" (click)="sendFeedback()">
                      {{ 'translateSend' | translate }}
                      <mat-icon svgIcon="send"></mat-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-col-hld">
                <div class="illustration-hld contact"></div>
              </div>
            </div>
          </div>
  -->
</div>
